import { intersection } from 'lodash';

export function getItemPaidDeposits(deposits) {
  return deposits.map((deposit) => ({
    id: deposit.id,
    amount: deposit.amount,
    date: deposit?.payment?.date || deposit.created_at,
  }));
}

export function getItemAvailableDeposits(
  item,
  selectedDeposits,
  paymentMethodsOfSelectedDeposits,
) {
  const listingDeposits = item.listing?.deposits || {};

  const paidDepositNames = item.deposits.reduce((acc, deposit) => ({
    ...acc,
    [deposit.name]: true,
  }), {});

  const isDepositUnpaid = (depositName) => !paidDepositNames[depositName];

  const isDepositSelected = (depositName) => selectedDeposits.find((selected) =>
          selected.itemId === item.id && selected.name === depositName);

  const hasPaymentMethodsEnabled = (depositName) => {
    return listingDeposits[depositName]?.amount && (
      listingDeposits[depositName]?.transfer ||
      listingDeposits[depositName]?.card
    );
  };

  return Object.keys(listingDeposits)
    .filter((depositName) => (
      isDepositUnpaid(depositName) &&
      hasPaymentMethodsEnabled(depositName)
    ))
    .map((depositName) => {
      const paymentMethods = [
        ...(listingDeposits[depositName]?.transfer ? ['transfer'] : []),
        ...(listingDeposits[depositName]?.card ? ['card'] : []),
      ];

      return {
        ...listingDeposits[depositName],
        itemId: item.id,
        name: depositName,
        selected: isDepositSelected(depositName),
        disabled: selectedDeposits.length &&
          !intersection(paymentMethods, paymentMethodsOfSelectedDeposits).length,
        paymentMethods,
      };
    });
}
